import {
  CateReq,
  CateDef,
  ListUserModelsDef,
  CatePredictReq,
  CatePredictDef,
  ITEOptionDef,
  ConditionalEffectsDef,
  RenameModelReq
} from "../type/cate-def";

export class CateAdapter {
  static toInputDTO(req: CateReq): any {
    return {
      is_cate_calculation: req.is_cate_calculation,
      outcome: req.outcome,
      treatment: req.treatment,
      covariates: req.covariates,
      treatment_binarize_threshold: req.treatment_binarize_threshold,
      lag: req.lag,
      confounders: req.confounders,
      cate_model_id: req.cate_model_id,
      asset_id: req.asset_id
    };
  }

  static toOutputDTO(data: any): CateDef {
    return {
      title: data.title,
      all_cates: data.all_cates || { key: { name: "", value: "" }, values: [] },
      cates_by_conditions: (data.cates_by_conditions || data.cates_by_condition)?.map((condition: any) => ({
        key: condition.key || { name: "", value: "" },
        values: this.sortValuesByLevel(condition.values || [])
      })) || [],
      warnings: Array.isArray(data.warnings) ? data.warnings : undefined
    };
  }

  // レベル順にソートするヘルパーメソッド
  private static sortValuesByLevel(values: any[]): any[] {
    return values.sort((a, b) => {
      const levelA = this.extractLevelNumber(a.label);
      const levelB = this.extractLevelNumber(b.label);
      return levelA - levelB;
    });
  }

  // ラベルからレベル番号を抽出
  private static extractLevelNumber(label: string | null): number {
    if (!label) return 999; // nullの場合は最後に
    const match = label.match(/レベル(\d+)/);
    return match ? parseInt(match[1], 10) : 999;
  }
}

export class ListUserModelsAdapter {
  static toInputDTO(): any {
    return {};
  }

  static toOutputDTO(data: any): ListUserModelsDef {
    return {
      models: data.models?.map((model: any) => ({
        model_id: model.model_id,
        model_name: model.model_name,
        login_user_id: model.login_user_id,
        asset_id: model.asset_id,
        outcome_node: model.outcome_node,
        treatment_node: model.treatment_node,
        covariate_nodes: model.covariate_nodes || [],
        model_saved_path: model.model_saved_path,
        dataset_saved_path: model.dataset_saved_path,
        discr_dataset_saved_path: model.discr_dataset_saved_path,
        node_names_map: model.node_names_map,
        discretization_level_labels: model.discretization_level_labels,
        created_at: model.created_at,
        updated_at: model.updated_at
      })) || []
    };
  }
}

export class CatePredictAdapter {
  static toInputDTO(req: CatePredictReq): any {
    return {
      covariate_values: req.covariate_values
    };
  }

  static toOutputDTO(data: any): CatePredictDef {
    return {
      model_id: data.model_id,
      estimated_effect: data.estimated_effect
    };
  }
}

export class ITEOptionsAdapter {
  static toInputDTO(): any {
    return {};
  }

  static toOutputDTO(data: any): ITEOptionDef {
    return {
      user_ids: data.user_ids || [],
      date_options: data.date_options || {}
    };
  }
}

export class ConditionalEffectsAdapter {
  static toInputDTO(): any {
    return {};
  }

  static toOutputDTO(data: any): ConditionalEffectsDef {
    return {
      all_user_ids: data.all_user_ids || [],
      data: data.data || {}
    };
  }
}

export class RenameModelAdapter {
  static toInputDTO(req: RenameModelReq): any {
    return {
      new_name: req.new_name
    };
  }

  static toOutputDTO(data: any): string {
    return data as string;
  }
}